module.exports = __webpack_public_path__ + "img/push-website-update.5be06a2a.png";